export default "__VITE_ASSET__00c7cd29__"